import {Link} from 'react-router-dom';
import logo from '../../assets/images/polyglow-logo.svg';
import { homeIcons } from '../../assets/images/home';
import { motion } from 'framer-motion';

const Header = () => {
    return (
        <motion.header id="homeHeader" 
        initial={{ opacity: 0, x: -150 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 2 }}>
            <div className="content">
                <Link to="/" className="logo-anaimation">
                    <img src={logo} className="logo-polyglow" alt="Logo Polyglowth"/>
                </Link>
                <div className="language-selector">
                    <div name="language" id="languageSelector">
                        <p>Langue du site : Français</p>
                    </div>
                    <div className="languages">
                        <div className="fr language active">
                            <img src={homeIcons.fr} alt="Fr"/>
                            <p>Français</p>
                        </div>
                        <div className="en language">
                            <img src={homeIcons.en} alt="En"/>
                            <p>Anglais</p>
                        </div>
                        <img src={homeIcons.lang} className="language-icon"/>
                    </div>
                </div>
            </div>
        </motion.header>
    );
};


export default Header;